export default {
      id: "icon-arrow-button-usage",
      viewBox: "0 0 39 39",
      url: "../icon/" + "icons.svg#icon-arrow-button-usage",
      toString: function () {
        return this.url;
      }
    }